module.exports = __webpack_public_path__ + "img/disc-2.1f09dfbd.png";